module.exports = function () {
    let win = null;

    function PopupWindowService() {
        window.onbeforeunload = function () {
            this.close();
        }.bind(this);
    }

    PopupWindowService.prototype.popupInit = function (windowName, width, height) {
        const w = window.outerWidth,
              h = window.outerHeight,
              x = window.screenLeft,
              y = window.screenTop,
              leftPos = ((w - width) / 2) + x,
              topPos = ((h - height) / 2) + y;

        win = window.open('', windowName, `width=${width}, height=${height}, top=${topPos}, left=${leftPos}, toolbar=no, location=no, menubar=no, resizable=no`);
        win.focus();
    };

    PopupWindowService.prototype.setUrl = function (url) {
        win.location.href = url;
    };

    PopupWindowService.prototype.setError = function (message) {
        const tempate =
`
<html>
    <head>
        <title>Error</title>
        <script type="text/javascript">
            window.opener.WowLinkingResult = { value: false, errorMessage: "` + message + `" };
            window.opener = null;
            window.close();
        </script>
    </head>
    <body>
    </body>
</html>
`;
        win.document.write(tempate);
    };

    PopupWindowService.prototype.setFocus = function () {
        if (win != null && !win.closed) {
            win.focus();
        }
    };

    PopupWindowService.prototype.close = function () {
        if (win != null && !win.closed) {
            win.close();
            win = null;
        }
    };

    PopupWindowService.prototype.isClosed = function () {

        if (win == null) {
            return true;
        }

        if (win.closed) {
            win = null;
            return true;
        }

        return false;
    };

    return new PopupWindowService();
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/popupwindowservice/popup-window-service.js
 **/